module.exports = __webpack_public_path__ + "img/advantage1.96d5ce3d.png";